module.exports = __webpack_public_path__ + "img/mastercard1.9283c742.png";